export default "__VITE_ASSET__778caf7d__"